import React from "react";
import SaitButton from "../atomic/SaitButton";
import NomeFileExcel from "../template/NomeFileExcel";
import PivotTableChartIcon from "@mui/icons-material/PivotTableChart";

export default function GridToolbarFilterButton(props) {
	const [openPivot, setOpenPivot] = React.useState(false);

	return (
		<>
			<NomeFileExcel
				open={openPivot}
				close={() => setOpenPivot(false)}
				exportFunction={props.pivotFunction}
				exportParams={{
					rowCount: props.rowCount,
					columns: props.columns,
					columnsVisibility: props.columnsVisibility,
					fetchDataForExcel: props.fetchDataForExcel,
				}}
			/>
			<SaitButton
				text="Pivot"
				loading={props.isFiltering}
				onClick={() => setOpenPivot(true)}
				startIcon={<PivotTableChartIcon />}
				variant="text"
				disabled={props.rows.length === 0}
			/>
		</>
	);
}
